import { COLORS, RANGES, WORKTOPS } from './cloudinaryImages'
import { RANGE_PRICES, WORKTOP_PRICES } from './prices'

const sections = [
  {
    id: 'range',
    type: 'range',
    title: 'Køkkenmodeller',
    shortTitle: 'Køkken',
    description: 'Vælg din køkkenmodel.',
    tooltip: {
      title: 'Vores køkkenmodeller',
      description: [
        'Vi tilbyder et bredt sortiment af forskellige køkkenmodeller. Prisen kan variere for samme model afhængigt af farve- og materialevalg.',
      ],
    },
    cards: [
      {
        title: 'Forever Oak',
        collection: 'Invita',
        description:
          'Forever Oak er et unikt møde mellem æstetisk design og funktionelle detaljer, udført i solide materialer, der holder til livet. Præcis som du drømmer om at leve det.',
        colors: COLORS.foreverOak,
        prices: {
          small: RANGE_PRICES.foreverOak[0],
          medium: RANGE_PRICES.foreverOak[1],
          large: RANGE_PRICES.foreverOak[2],
        },
        image: RANGES.foreverOak,
      },
      {
        title: 'Athena',
        collection: 'Invita',
        description:
          'Athena er et enkelt køkken med et strømlinet design, som passer til alt fra det moderne byggeri til den moderniserede herskabslejlighed eller patriciervilla.',
        colors: COLORS.athena,
        prices: {
          small: RANGE_PRICES.athena[0],
          medium: RANGE_PRICES.athena[1],
          large: RANGE_PRICES.athena[2],
        },
        image: RANGES.athena,
      },
      {
        title: 'Glød',
        collection: 'Invita',
        description:
          'Glød er på én gang organisk blødt og grafisk stramt. De vandrette årer i træet brydes smukt af de tre fingertapninger samt de massive lodrette egetræslister, der skjuler skuffeskinnerne.',
        colors: COLORS.glod,
        prices: {
          small: RANGE_PRICES.glod[0],
          medium: RANGE_PRICES.glod[1],
          large: RANGE_PRICES.glod[2],
        },
        image: RANGES.glod,
      },
      {
        title: 'Nordic',
        collection: 'Invita',
        description:
          'Det romantiske Nordic-køkken er karakteriseret ved smukke fyldninger og glaslåger med sprosser. De klassiske detaljer giver Nordic et stilfuldt look, der aldrig går af mode.',
        colors: COLORS.nordic,
        prices: {
          small: RANGE_PRICES.nordic[0],
          medium: RANGE_PRICES.nordic[1],
          large: RANGE_PRICES.nordic[2],
        },
        image: RANGES.nordic,
      },
      {
        title: 'Northern Shaker',
        collection: 'Invita',
        description:
          'I Northern Shaker-køkkenet bliver du mødt af solidt håndværk med moderne linjer på fyldningslågerne kombineret med olivengrønne flader. Åbn skufferne, og frem titter håndtappede træskuffer, der sætter trumf under køkkenkvaliteten.',
        colors: COLORS.northernShaker,
        prices: {
          small: RANGE_PRICES.northernShaker[0],
          medium: RANGE_PRICES.northernShaker[1],
          large: RANGE_PRICES.northernShaker[2],
        },
        image: RANGES.northernShaker,
      },
      {
        title: 'Ikon',
        collection: 'Invita',
        description:
          'Ikon er snedkerkøkkenet, som giver dig oplevelsen af, at naturen er flyttet indenfor. Det massive egetræskøkken har smukke trælameller, som gør designet uforgængeligt.',
        colors: COLORS.ikon,
        prices: {
          small: RANGE_PRICES.ikon[0],
          medium: RANGE_PRICES.ikon[1],
          large: RANGE_PRICES.ikon[2],
        },
        image: RANGES.ikon,
      },
      {
        title: 'Square finér',
        collection: 'Invita',
        description:
          'Square er et klassisk køkkendesign, som vækker nostalgien til live på en moderne facon. Det kvadratiske look er nemt at mikse med åbne, finerede reoler og væghængte frame-rammer.',
        colors: COLORS.square,
        prices: {
          small: RANGE_PRICES.squareFiner[0],
          medium: RANGE_PRICES.squareFiner[1],
          large: RANGE_PRICES.squareFiner[2],
        },
        image: RANGES.square,
      },
      {
        title: 'Cover',
        collection: 'Invita',
        description:
          'Designet på Cover er udført i Fenix laminat, som er enormt slidstærk og utrolig blød og behageligt at røre ved. Cover tåler hverdagen i alle henseender og er samtidig visuelt vellykket. Det er et drømmedesign til det moderne køkken.',
        colors: COLORS.cover,
        prices: {
          small: RANGE_PRICES.cover[0],
          medium: RANGE_PRICES.cover[1],
          large: RANGE_PRICES.cover[2],
        },
        image: RANGES.cover,
      },
      {
        title: 'Everline finér',
        collection: 'Invita',
        description:
          'Det er i høj grad det buede greb, der definerer designet på Everline-køkkenet. Det buede trægreb bløder det minimalistiske udtryk op og tilfører et naturligt strejf, der klæder de fleste hjem.',
        colors: COLORS.everline,
        prices: {
          small: RANGE_PRICES.everlineFiner[0],
          medium: RANGE_PRICES.everlineFiner[1],
          large: RANGE_PRICES.everlineFiner[2],
        },
        image: RANGES.everline,
      },
      {
        title: 'Comet',
        collection: 'Invita',
        description:
          'Comet er kendetegnet ved glatte overflader af slidstærk laminat og smukke, massive trækanter.Resultatet er et praktisk og stilrent køkken, der er perfekt til den aktive familie, der elsker at lave mad og opholde sig i køkkenet.',
        colors: COLORS.comet,
        prices: {
          small: RANGE_PRICES.comet[0],
          medium: RANGE_PRICES.comet[1],
          large: RANGE_PRICES.comet[2],
        },
        image: RANGES.comet,
      },
      {
        title: 'Newline',
        collection: 'Invita',
        description:
          'Newline er skabt med et udgangspunkt i rene linjer og minimalisme uden at dit køkken skal blive kedeligt. Det er grebet, der giver modspil til de rene enkle linjer.',
        colors: COLORS.newline,
        prices: {
          small: RANGE_PRICES.newline[0],
          medium: RANGE_PRICES.newline[1],
          large: RANGE_PRICES.newline[2],
        },
        image: RANGES.newline,
      },
      {
        title: 'Urban',
        collection: 'Invita',
        description:
          'Urban er et stilrent køkken, hvor der er ikke nogle greb, der stikker ud og optager plads. Derudover giver det moderne køkken uden greb et legende og elegant design, som samtidig er yderst brugervenligt.',
        colors: COLORS.urban,
        prices: {
          small: RANGE_PRICES.urban[0],
          medium: RANGE_PRICES.urban[1],
          large: RANGE_PRICES.urban[2],
        },
        image: RANGES.urban,
      },
      {
        title: 'Highline',
        collection: 'Invita',
        description:
          'Highline er et minimalistisk køkken uden greb,der i al sin enkelthed er skabt af rene linjer og et smukt tidløs design.',
        colors: COLORS.highline,
        prices: {
          small: RANGE_PRICES.highline[0],
          medium: RANGE_PRICES.highline[1],
          large: RANGE_PRICES.highline[2],
        },
        image: RANGES.highline,
      },
      {
        title: 'Dark Nature',
        collection: 'Invita',
        description:
          'Dark Nature er inspireret af et varmt og enkelt skandinavisk formsprog. Den mørke træglød samt de naturlige og rå materialer skaber et varmt og eksklusivt køkken med et unikt udtryk.',
        colors: COLORS.darkNature,
        prices: {
          small: RANGE_PRICES.darkNature[0],
          medium: RANGE_PRICES.darkNature[1],
          large: RANGE_PRICES.darkNature[2],
        },
        image: RANGES.darkNature,
      },
    ],
  },
  {
    id: 'units',
    title: 'Køkkenstørrelse',
    shortTitle: 'Størrelse',
    type: 'units',
    description: 'Vælg størrelse på dit køkken.',
    tooltip: {
      title: 'Køkkenstørrelse',
      description: [
        'I et mellemstørrelse køkken får du eksempelvis plads til 5 underskabe, 2 overskabe og 3 højskabe.',
      ],
    },
    cards: [
      {
        type: 'medium',
        title: 'Mellemstørrelse',
        price: 0,
        image:
          'https://assets.nobiadigital.com/image/upload/f_auto,q_auto,w_600/v1673525426/Invita/Illustrations/medium.png',
      },
    ],
  },
  {
    id: 'worktops',
    title: 'Bordplade',
    type: 'simple',
    description: 'Vælg hvilken type bordplade, du vil have i dit køkken.',
    tooltip: {
      title: 'Vores bordplader',
      description: [
        'Vælg mellem laminat, massivt træ og granit. Kombiner med størrelsen på køkkenet og få et priseksempel.',
        'Vi tilbyder også andre bordplader end dem, der er vist i prisberegneren. Er du interesseret i at se alle bordplader, kan du finde dem [her](https://www.invita.dk/kokken/materialer-og-tilbehor/bordplader/).',
      ],
    },
    cards: [
      {
        title: 'Laminat',
        description:
          'Laminatbordplader fås i et væld af farver, som kan gøre dit køkken unikt. Laminatbordplader er kendetegnet ved, at de er utroligt holdbare og nemme at vedligeholde.',
        prices: {
          small: WORKTOP_PRICES.laminate[0],
          medium: WORKTOP_PRICES.laminate[1],
          large: WORKTOP_PRICES.laminate[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Massivt træ',
        description:
          'Træbordpladerne kommer i forskellige prisklasser, og kvalitetstræ koster selvsagt lidt mere. Træbordpladerne nemme at vedligeholde, da ridser nemt kan slibes af, så bordpladen står som ny.',
        prices: {
          small: WORKTOP_PRICES.solidTimber[0],
          medium: WORKTOP_PRICES.solidTimber[1],
          large: WORKTOP_PRICES.solidTimber[2],
        },
        image: WORKTOPS.wood,
      },
      {
        title: 'Granit',
        description:
          'De smukke granitbordplader fås i et væld af mønstre og farver, og vælger du en bordplade i granit er du sikker på at få et helt unikt køkken. En granitbordplade kræver ikke meget vedligehold, og med denne bordplade får du høj kvalitet, som holder i mange år.',
        prices: {
          small: WORKTOP_PRICES.granite[0],
          medium: WORKTOP_PRICES.granite[1],
          large: WORKTOP_PRICES.granite[2],
        },
        image: WORKTOPS.granite,
      },
      {
        title: 'Marmor',
        description:
          'De smukke marmorbordplader fås i et væld af mønstre og farver, og vælger du en bordplade i marmor er du sikker på at få et helt unikt køkken. En marmorbordplade kræver meget vedligehold, med denne bordplade får du høj kvalitet, som holder i mange år.',
        prices: {
          small: WORKTOP_PRICES.marble[0],
          medium: WORKTOP_PRICES.marble[1],
          large: WORKTOP_PRICES.marble[2],
        },
        image: WORKTOPS.marble,
      },
    ],
  },
  {
    id: 'estimate',
    title: 'Estimat',
    type: 'summary',
    description: '',
    tooltip: {},
  },
]

export default sections
